var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M3.85,2.79,1.06,0,0,1.06,2.79,3.85,0,6.65,1.06,7.71l2.79-2.8,2.8,2.8L7.71,6.65l-2.8-2.8,2.8-2.79L6.65,0Z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }